import { render } from "./SidebarLinks.vue?vue&type=template&id=5cde1bf3"
import script from "./SidebarLinks.vue?vue&type=script&lang=js"
export * from "./SidebarLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__